import { createReducer, on } from '@ngrx/store';

import { goToProjects, setProject } from '../../core/store';
import { refreshDatablocks } from '../../expositions/store';
import {
	bulkDelete,
	bulkDeleteFail,
	bulkDeleteSuccess,
	constructDatablockList,
	constructDatablockListSuccess,
	deleteDatablock,
	deleteDatablockFail,
	deleteDatablockSuccess,
	fetchDatablockListFail,
	fetchDatablockListSuccess,
	persistDatablockStarted,
	persistDatablockStopped,
	persistenceActionFinish,
	persistenceActionsAccepted,
	persistDatablocks,
	repersistDatablocks,
	repersistDatablockStarted,
	repersistDatablockStopped,
	trackAction,
	unpersistDatablocks,
	unpersistDatablockStarted,
	unpersistDatablockStopped,
	updateDatablocksExpositionsCountSuccess,
} from './datablock.actions';
import { DatablockOriginalSliceState } from './datablock.state';

export const datablockOriginalReducer =
	createReducer<DatablockOriginalSliceState>(
		new DatablockOriginalSliceState(),
		on(goToProjects, setProject, (state) => state.clear()),
		on(constructDatablockList, refreshDatablocks, (state) =>
			state.setLoading(true)
		),
		on(fetchDatablockListFail, (state) => state.setLoading(false)),
		on(constructDatablockListSuccess, (state, action) =>
			state.setDatablockList(action.datablockList)
		),
		on(fetchDatablockListSuccess, (state, action) =>
			state.setLoading(false).setDatablockList(action.datablockList)
		),
		on(deleteDatablock, bulkDelete, (state) => state.setLoading(true)),
		on(deleteDatablockFail, (state) => state.setLoading(false)),
		on(
			persistDatablockStarted,
			repersistDatablockStarted,
			unpersistDatablockStarted,
			(state, action) =>
				state.setDatablockList(
					state.list.setJob(action.datablockId, true, action.jobId)
				)
		),
		on(
			persistDatablockStopped,
			repersistDatablockStopped,
			unpersistDatablockStopped,
			(state, action) =>
				state.setDatablockList(
					state.list.setJob(action.datablockId, false, action.jobId)
				)
		),
		on(persistenceActionFinish, (state, action) =>
			state.setDatablockList(
				state.list
					.updatePersistenceInfo(action.datablockId, action.persistenceInfo)
					.setJobId(action.datablockId, null)
			)
		),
		on(trackAction, (state, action) =>
			state.setDatablockList(
				state.list.setJobId(action.datablockId, action.jobId)
			)
		),
		on(updateDatablocksExpositionsCountSuccess, (state, action) =>
			state.setDatablockList(action.datablockList)
		),
		on(
			persistDatablocks,
			repersistDatablocks,
			unpersistDatablocks,
			deleteDatablock,
			bulkDelete,
			(state) => state.setActionInProgress(true)
		),
		on(
			persistenceActionsAccepted,
			deleteDatablockSuccess,
			deleteDatablockFail,
			bulkDeleteSuccess,
			bulkDeleteFail,
			(state) => state.setActionInProgress(false)
		)
	);
